import { jsx, jsxs } from "react/jsx-runtime";
import dedent from "dedent";
import { Children } from "react";
import { flattenChildren } from "../../utils/flattenChildren.mjs";
import { Box } from "../Box/Box.mjs";
import { Divider } from "../Divider/Divider.mjs";
import { negativeMargin } from "../../css/negativeMargin/negativeMargin.mjs";
import { resolveResponsiveProp } from "../../utils/resolveResponsiveProp.mjs";
import { columnsWide, columnsDesktop, columnsTablet, columnsMobile } from "./Tiles.css.mjs";
import { mapResponsiveValue } from "../../css/atoms/sprinkles.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
const Tiles = ({
  children,
  space = "none",
  columns = 1,
  dividers,
  data,
  ...restProps
}) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof dividers !== "undefined") {
      console.warn(
        dedent`
          The "dividers" prop is deprecated and will be removed in v33 to enable CSS gap in layout components.
          Update your usage now to make upgrading easier by manually inserting "Divider" components as required:
            %c- <Tiles space="..." dividers>
            %c+ <Tiles space="...">
            %c    <Component>{item}</Component>
            %c+   <Stack space="...">
            +     <Hidden above="mobile"><Divider /></Hidden>
            %c      <Component>{item}</Component>
            %c+   </Stack>
            +   <Stack space="...">
            +     <Hidden above="mobile"><Divider /></Hidden>
            %c      <Component>{item}</Component>
            %c+   </Stack>
            %c  </Tiles>
          See migration guide for details: https://github.com/seek-oss/braid-design-system/blob/master/docs/Removing%20dividers%20support%20from%20layout%20components.md
        `,
        "color: red",
        "color: green",
        "color: inherit",
        "color: green",
        "color: inherit",
        "color: green",
        "color: inherit",
        "color: green",
        "color: inherit"
      );
    }
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: negativeMargin("top", space),
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsx(
        Box,
        {
          display: "flex",
          flexWrap: "wrap",
          className: negativeMargin("left", space),
          children: Children.map(flattenChildren(children), (child, i) => /* @__PURE__ */ jsx(
            Box,
            {
              minWidth: 0,
              className: resolveResponsiveProp(
                columns,
                columnsMobile,
                columnsTablet,
                columnsDesktop,
                columnsWide
              ),
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  height: "full",
                  paddingTop: space,
                  paddingLeft: space,
                  children: [
                    dividers && i > 0 ? /* @__PURE__ */ jsx(
                      Box,
                      {
                        paddingBottom: space,
                        display: mapResponsiveValue(
                          columns,
                          (column) => column === 1 ? "block" : "none"
                        ),
                        children: typeof dividers === "string" ? /* @__PURE__ */ jsx(Divider, { weight: dividers }) : /* @__PURE__ */ jsx(Divider, {})
                      }
                    ) : null,
                    child
                  ]
                }
              )
            }
          ))
        }
      )
    }
  );
};
export {
  Tiles
};
